import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, Divider, useMediaQuery } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const CardPoste = ({ 
  nomPosteFrancais, 
  nomPosteHebreu, 
  category,
  needInterview,
  forWomen,
  forMen,
  forVolunteers,
  chanceToGetJob,
  dapar,
  profile,
  imc,
  ivrit,
  caregiving,
  leadership,
  teamwork,
  discipline,
  maturity,
  perseverance,
  InformationProcessing,
  management,
  technicalOperation,
  attention,
  perception,
  instruction,
  description,
  formation,
  posteLocation,
  recruitmentProcess
}) => {
  console.log(description);
  const [isHovered, setIsHovered] = useState(false);
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:992px)');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const requirements = [
    { label: 'טיפול באדם – Empathie et relation inter-personelle', value: caregiving },
    { label: 'פיקוד – Leadership', value: leadership },
    { label: 'עבודת צוות – Travail d’équipe', value: teamwork },
    { label: 'התנהגות מסגרתית – Comportement dans un groupe', value: discipline },
    { label: 'בגרות ובשלות – Maturité et Sérénité', value: maturity },
    { label: 'השקעה והתמדה – Investissement et persévérance', value: perseverance },
    { label: 'עיבוד מידע – Traitement de l’information', value: InformationProcessing },
    { label: 'ניהול וארגון – Gestion et organisation', value: management },
    { label: 'הפעלה טכנית – Maitrise technique', value: technicalOperation },
    { label: 'קשב מתמשך – Concentration', value: attention },
    { label: 'תפיסת מרחב – Perception spatiale', value: perception },
    { label: 'הדרכה – Instruction', value: instruction }
  ];

  return (
    <>
      <div
        style={{
          borderRadius: '10px',
          border: '1px solid #ededed',
          padding: '1em',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          boxShadow: isHovered
            ? '0 .5rem 1rem #00000026' 
            : '0px 4px 6px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#fff',
          transition: 'box-shadow 0.3s ease',
          cursor: 'pointer'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClickOpen}
      >
        <div style={{fontFamily: 'Montserrat', fontWeight: '700', color: '#013D51', fontSize: '1.41rem'}}>{nomPosteFrancais}</div>
        <div style={{fontFamily: 'Montserrat', fontWeight: '500', color: '#013D51', fontSize: '1.2rem'}}>{nomPosteHebreu}</div>
        <div style={{fontFamily: 'Montserrat', fontWeight: '400', color: 'gray', fontSize: '1rem'}}>{category}</div>
      </div>

      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          style: {
            borderRadius: isMobile ? 0 : '15px',
            padding: isMobile ? 0 : '2rem',
            minHeight: isMobile ? '100vh' : '80vh',
            background: '#fff',
          }
        }}
      >
        <DialogTitle sx={{ textAlign: 'center', pb: 2 }}>
          <Typography variant="h4" style={{ 
            fontFamily: 'Montserrat', 
            fontWeight: '700', 
            color: '#013D51',
            marginBottom: '0.5rem',
            fontSize: isMobile ? '1.5rem' : '2.2rem',
            textAlign: 'center'
          }}>
            {nomPosteFrancais}
          </Typography>
          <Typography variant="h5" style={{ 
            fontFamily: 'Montserrat', 
            fontWeight: '500', 
            color: '#013D51',
            fontSize: isMobile ? '1.2rem' : '1.5rem',
            textAlign: 'center'
          }}>
            {nomPosteHebreu}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {/* Description */}
          {description && (
            <div style={{ marginBottom: '2rem' }}>
              <Typography variant="h6" style={{ fontFamily: 'Montserrat', fontWeight: 600, color: '#013D51', marginBottom: '0.5rem' }}>
                Description
              </Typography>
              <ReactMarkdown>{description}</ReactMarkdown>
            </div>
          )}
          <Divider sx={{ my: 2 }} />
          {/* Données principales */}
          <Grid container spacing={3} sx={{ marginBottom: '2rem' }}>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Catégorie :</b> {category}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Profil :</b> {profile}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>IMC :</b> {imc}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Dapar :</b> {dapar}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Entretien requis :</b> {needInterview === 'Oui' ? 'Oui' : 'Non'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Chances d'obtenir le poste :</b> {chanceToGetJob}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Pour femmes :</b> {forWomen ? 'Oui' : 'Non'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Pour hommes :</b> {forMen ? 'Oui' : 'Non'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Pour volontaires :</b> {forVolunteers ? 'Oui' : 'Non'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography><b>Ivrit :</b> {ivrit}</Typography>
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          {/* Compétences requises */}
          <div style={{ marginBottom: '2rem' }}>
            <Typography variant="h6" style={{ fontFamily: 'Montserrat', fontWeight: 600, color: '#013D51', marginBottom: '0.5rem' }}>
              Compétences requises
            </Typography>
            <Grid container spacing={2}>
              {requirements.map((req, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Typography style={{ fontFamily: 'Montserrat', color: '#013D51', fontSize: '1rem', marginBottom: '0.5rem' }}>
                    <span style={{ color: 'gray', fontWeight: '400' }}>{req.label}</span>
                    <div style={{ color: '#013D51', fontWeight: '700', marginTop: '0.2rem' }}>{req.value}</div>
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </div>
          {/* Formation */}
          {formation && (
            <div style={{ marginBottom: '2rem' }}>
              <Typography variant="h6" style={{ fontFamily: 'Montserrat', fontWeight: 600, color: '#013D51', marginBottom: '0.5rem' }}>
                Formations
              </Typography>
              <ReactMarkdown>{formation}</ReactMarkdown>
            </div>
          )}
          {/* Lieu de service */}
          {posteLocation && (
            <div style={{ marginBottom: '2rem' }}>
              <Typography variant="h6" style={{ fontFamily: 'Montserrat', fontWeight: 600, color: '#013D51', marginBottom: '0.5rem' }}>
                Lieu de service
              </Typography>
              <ReactMarkdown>{posteLocation}</ReactMarkdown>
            </div>
          )}
          {/* Processus de recrutement */}
          {recruitmentProcess && (
            <div style={{ marginBottom: '2rem' }}>
              <Typography variant="h6" style={{ fontFamily: 'Montserrat', fontWeight: 600, color: '#013D51', marginBottom: '0.5rem' }}>
                Processus de recrutement
              </Typography>
              <ReactMarkdown>{recruitmentProcess}</ReactMarkdown>
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', p: 3 }}>
          <Button 
            onClick={handleClose} 
            variant="contained"
            sx={{
              backgroundColor: '#013D51',
              color: 'white',
              fontFamily: 'Montserrat',
              fontWeight: '600',
              padding: '0.5rem 2rem',
              '&:hover': {
                backgroundColor: '#012a3a'
              }
            }}
          >
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CardPoste;
